const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLaosLabour',
    accessToken: 'accessTokenLaosLabour',
    userRole: 'userRole',
  }
}

export default AppConfig;
